import { render, staticRenderFns } from "./Edu_calendar.vue?vue&type=template&id=4b232bd6&scoped=true&"
import script from "./Edu_calendar.vue?vue&type=script&lang=js&"
export * from "./Edu_calendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b232bd6",
  null
  
)

export default component.exports